import {
  ActionType,
  IConsultationCSVResponse,
  DownloadConsultationCSVPayload,
} from "models/consultations/downloadConsultationCSV";

export const downloadConsultationCSVAction = (
  payload: DownloadConsultationCSVPayload
) => {
  return {
    type: ActionType.DOWNLOAD_CONSULTATION_CSV,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DOWNLOAD_CONSULTATION_CSV_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IConsultationCSVResponse) => {
  return {
    type: ActionType.DOWNLOAD_CONSULTATION_CSV_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.DOWNLOAD_CONSULTATION_CSV_RESET,
  };
};
